import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_lots_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { paging?: { top?: number, skip?: number }, filters?: { vendor_lot_id?: number, lookup?: string, material_id?: number, material_lookup?: string, project_id?: number, project_lookup?: string, owner_id?: number, owner_lookup?: string, receive_date_from?: string, receive_date_to?: string, last_receive_date_from?: string, last_receive_date_to?: string, vendor_lot_lookup?: string, lot_id?: number }, exclude?: { user_defined_fields?: boolean } }): Promise<{ lots?: $frontendTypes.FootprintApiManager.public_lot[], errors?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

